import { approvalMethodNoticePeriodModel, relationshipModel } from "../../../../models";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
import { getInvoicesApprovalMethodChangeBullet } from "../../../../business-logic/amendmentsLogic";
import { SpecificTerm } from "./CommonComponents";
import { jsx as _jsx } from "react/jsx-runtime";
const AgreementInvoicesApprovalMethod = props => {
  const {
    relationship,
    testid
  } = props;
  const updated = relationshipModel.updatedInvoicesApprovalMethod(relationship);
  const actual = relationshipModel.actualInvoicesApprovalMethod(relationship);
  const isAutoApproval = approvalMethodNoticePeriodModel.isAutoApproval(actual);
  const changeBullet = updated ? getInvoicesApprovalMethodChangeBullet(relationship.invoicesApprovalMethod, updated.value()) : null;
  return isAutoApproval || updated ? /*#__PURE__*/_jsx(SpecificTerm, {
    field: "Out of scope charges",
    value: approvalMethodNoticePeriodModel.invoicesDescription(actual),
    testid: testid + 'invoice-notice-period',
    changes: changeBullet && /*#__PURE__*/_jsx(AmendmentChangesInAgreementView, {
      disableBorderRadius: true,
      items: [changeBullet],
      autoApprovalDate: relationshipModel.updatedInvoicesApprovalMethodAutoApprovalDate(relationship),
      testid: testid + 'invoice-notice-changes'
    })
  }) : null;
};
export default AgreementInvoicesApprovalMethod;